import type { Importance } from '../features/services/notificationsTypes';

export const NOTIFICATION_COUNT = 'NOTIFICATION_COUNT';
export const MAX_NOTIFICATION_PRIORITY = 'MAX_NOTIFICATION_PRIORITY';

interface IFrameWindow extends Window {
    // biome-ignore lint/suspicious/noExplicitAny: suppress out of convenience during migration to biome
    parentIFrame?: any;
    // biome-ignore lint/suspicious/noExplicitAny: suppress out of convenience during migration to biome
    iFrameResizer?: any;
}

interface IframeNotificationCountAction {
    type: typeof NOTIFICATION_COUNT;
    payload: {
        count: number;
    };
}

interface IframeNotificationPriorityAction {
    type: typeof MAX_NOTIFICATION_PRIORITY;
    payload: {
        importance: Importance;
    };
}

export const notificationCount = (count = 0): IframeNotificationCountAction => ({
    type: NOTIFICATION_COUNT,
    payload: {
        count,
    },
});

export const maxNotificationLevel = (importance: Importance): IframeNotificationPriorityAction => ({
    type: MAX_NOTIFICATION_PRIORITY,
    payload: {
        importance,
    },
});

export type IframeActionType = IframeNotificationCountAction | IframeNotificationPriorityAction;

export const dispatchMsgToParentIFrame = (action: IframeActionType) => {
    const payloadToSend = constructPayload(action);

    try {
        // Use iframe-resizer bridge if available
        if ('parentIFrame' in window) {
            // Please note that "window.parentIFrame" is not browser standard. It is injected by the iframe-resizer library.
            // This means, communication between this frame and the parent application ONLY works via this approach.
            // Also, the "window.parentIFrame" can only be injected if the iframe-resizer content window is loaded. Replacing the
            // URL at runtime will lead to cut off event listeners.
            // While this usage is fine for automatic resizing behavior, it will not listen to any other postMessage send
            // via browser API. In future, this should be changed to remove the tight coupling to iframe-resizer's API but
            // this would mean to also change the platform-notification-component.
            (window as IFrameWindow).parentIFrame.sendMessage(payloadToSend, '*');

            return;
        }

        // Fallback to native browser postMessage
        window.top?.postMessage(payloadToSend, '*');
    } catch (error) {
        console.error('[dispatchMessageToParent] Failed to send message:', error);
    }
};

const constructPayload = (action: IframeActionType): IframeActionType => {
    switch (action.type) {
        case NOTIFICATION_COUNT: {
            return { type: NOTIFICATION_COUNT, payload: action.payload };
        }
        case MAX_NOTIFICATION_PRIORITY: {
            return { type: MAX_NOTIFICATION_PRIORITY, payload: action.payload };
        }
    }
};
